// 判断各类型blur的时候value是否是空值
export function isEmptyValue(value, itemtype) {
    if (itemtype === 'residtxt') {
        return Object.keys(value).every(key => !value[key]?.value);
    } else if (itemtype === 'refer') {
        if (Array.isArray(value)) {
            return !value.length;
        } else {
            return !value.refpk;
        }
    } else {
        return (typeof value === 'boolean' && value !== true) && !!value;
    }
}

// 获取relation -> tables
export function getRelationTables(relation) {
    let { stores, configs } = this.props;
    let { tables, tabs: tabsInfo } = relation;
    return tables.filter(tableId => {
        let { hideTableTabs, customTabContent } = configs[tableId] || {},
            activeTab = stores[tableId].getActiveTab() || tableId;

        let tabs = tabsInfo[tableId].filter(tab => {
            return stores[tab].getAreaVisible() && (stores[tab].getMeta()?.[tab].areaVisible !== false || customTabContent?.[tab]);
        });

        let tabVisible = !hideTableTabs && tabs.length,
            bodyVisible = typeof customTabContent?.[activeTab] === 'function' ? customTabContent[activeTab](activeTab) : (hideTableTabs || tabs.length);
        
        return tabVisible || bodyVisible;
    });
}